import Vue from "vue";
import axios from "axios";
import { OportunityPending } from "@/columns";
import ActivityFlowDialogLocker from "@/components/activity_flow/ActivityFlowDialogLocker.vue";

const vue = new Vue();

export const OportunityPaymentgetTableData = async function (thiss) {
  //console.log("penddingPaymentgetTableData");
  //const axiosSource = axios.CancelToken.source();
  var request = null;
  if (request) cancel();
  const axiosSource = axios.CancelToken.source();
  request = { cancel: axiosSource.cancel, msg: "Loading..." };

  let tableData = [];

  if (
    /*
    thiss.currentUser.Roles.some(
      (e) => e.Id === 50 || e.Id === 4 || e.Id === 51
    )
    */
    thiss.currentUser.PositionID == 53 ||
    thiss.currentUser.PositionID == 37 ||
    thiss.currentUser.PositionID == 56 ||
    thiss.currentUser.PositionID == 16
  ) {
    //let Cod_Vendor = thiss.currentUser.PersonCode ? thiss.currentUser.PersonCode : null
    await vue.$http
      .get("/api/deals/ProspectingReportDetailsByVendedor", {
        params: {
          Cod_Vendor: thiss.currentUser.PersonCode
          //Cod_Support: null
        }
      })
      .then((response) => {
        tableData = response.data;
      })
      .catch((error) => {
        console.error("no funciona", error);
      });

    return tableData;
  } else {
    return tableData;
  }
};
const cancel = function () {
  this.request.cancel();
  this.clearOldRequest("Cancelled");
};

export const OportunityTaksColumns = OportunityPending;

export const OportunityPaymentActions = [
  {
    icon: "el-icon-edit",
    label: "Editar fecha",
    command: "edit-oportunity"
  }
];

export const OportunityPaymentActionHandler = async function (action) {
  ActivityFlowDialogLocker.methods.actionHandlerHelper(action);
};
